import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
//import { getFirestore } from "firebase/firestore";
//import { getAuth } from "firebase/auth";
//import "firebase/analytics";
//import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyALv1geP5mZpsHFt_71Tz0Q9FDTR5gP7ZA",
  authDomain: "joycap-my.firebaseapp.com",
  projectId: "joycap-my",
  storageBucket: "joycap-my.firebasestorage.app",
  messagingSenderId: "957355111503",
  appId: "1:957355111503:web:5b46b35c67b80c280ee63a",
  measurementId: "G-FG26463DCH",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
//firebase.analytics();
//const db = getFirestore(app);
//const auth = getAuth(app);

// Initialize Cloud Storage and get a reference to the service
//const storage = getStorage(app);

//export default firebase;

export { analytics };
